/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Overview_Nogametimes3Inputs */

const id_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada waktu game ditemukan`)
};

const ms_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada masa permainan ditemui`)
};

const da_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen spiltider fundet`)
};

const de_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Spielzeiten gefunden`)
};

const en_us2_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No game times found`)
};

const es_es2_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron tiempos de juego`)
};

const es_mx2_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron tiempos de juego`)
};

const fil_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang oras ng laro`)
};

const fr_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune durée trouvée`)
};

const it_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun tempo di gioco trovato`)
};

const hu_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem található játékidő`)
};

const nl_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen speeltijden gevonden`)
};

const no_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen spilletider funnet`)
};

const pl_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono czasów gry`)
};

const pt_br2_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum horário de jogo encontrado`)
};

const pt_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum tempo de jogo encontrado`)
};

const ro_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au găsit timpi de joc`)
};

const fi_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelille ei löytynyt läpäisyaikoja`)
};

const sv_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga speltider hittades`)
};

const vi_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy thời gian chơi game`)
};

const tr_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oyun süresi bulunamadı`)
};

const cs_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebyly nalezeny žádné herní časy`)
};

const bg_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени времена за игра`)
};

const ru_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Время прохождений не найдено`)
};

const uk_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Часів проходження не знайдено`)
};

const ar_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على أوقات للعبة`)
};

const hi_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई गेम समय नहीं मिला`)
};

const th_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบเวลาเล่นเกม`)
};

const ja_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲーム時間が見つかりません`)
};

const zh_cn2_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到游戏时间数据`)
};

const zh_hant1_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到遊戲時間資料`)
};

const ko_offerdetail_overview_nogametimes3 = /** @type {(inputs: Offerdetail_Overview_Nogametimes3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`게임 플레이 시간 정보 없음`)
};

/**
* | output |
* | --- |
* | "No game times found" |
*
* @param {Offerdetail_Overview_Nogametimes3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_overview_nogametimes3 = /** @type {((inputs?: Offerdetail_Overview_Nogametimes3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Overview_Nogametimes3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_overview_nogametimes3(inputs)
	if (locale === "ms") return ms_offerdetail_overview_nogametimes3(inputs)
	if (locale === "da") return da_offerdetail_overview_nogametimes3(inputs)
	if (locale === "de") return de_offerdetail_overview_nogametimes3(inputs)
	if (locale === "en-US") return en_us2_offerdetail_overview_nogametimes3(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_overview_nogametimes3(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_overview_nogametimes3(inputs)
	if (locale === "fil") return fil_offerdetail_overview_nogametimes3(inputs)
	if (locale === "fr") return fr_offerdetail_overview_nogametimes3(inputs)
	if (locale === "it") return it_offerdetail_overview_nogametimes3(inputs)
	if (locale === "hu") return hu_offerdetail_overview_nogametimes3(inputs)
	if (locale === "nl") return nl_offerdetail_overview_nogametimes3(inputs)
	if (locale === "no") return no_offerdetail_overview_nogametimes3(inputs)
	if (locale === "pl") return pl_offerdetail_overview_nogametimes3(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_overview_nogametimes3(inputs)
	if (locale === "pt") return pt_offerdetail_overview_nogametimes3(inputs)
	if (locale === "ro") return ro_offerdetail_overview_nogametimes3(inputs)
	if (locale === "fi") return fi_offerdetail_overview_nogametimes3(inputs)
	if (locale === "sv") return sv_offerdetail_overview_nogametimes3(inputs)
	if (locale === "vi") return vi_offerdetail_overview_nogametimes3(inputs)
	if (locale === "tr") return tr_offerdetail_overview_nogametimes3(inputs)
	if (locale === "cs") return cs_offerdetail_overview_nogametimes3(inputs)
	if (locale === "bg") return bg_offerdetail_overview_nogametimes3(inputs)
	if (locale === "ru") return ru_offerdetail_overview_nogametimes3(inputs)
	if (locale === "uk") return uk_offerdetail_overview_nogametimes3(inputs)
	if (locale === "ar") return ar_offerdetail_overview_nogametimes3(inputs)
	if (locale === "hi") return hi_offerdetail_overview_nogametimes3(inputs)
	if (locale === "th") return th_offerdetail_overview_nogametimes3(inputs)
	if (locale === "ja") return ja_offerdetail_overview_nogametimes3(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_overview_nogametimes3(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_overview_nogametimes3(inputs)
	return ko_offerdetail_overview_nogametimes3(inputs)
});
export { offerdetail_overview_nogametimes3 as "offerDetail.overview.noGameTimes" }